import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface FilterNameDialogData {
  defaultName: string;
}

@Component({
  selector: 'app-filter-name-dialog',
  template: `
    <div class="p-6">
      <h2 mat-dialog-title class="text-lg font-medium text-gray-900 mb-4">
        Save Filter
      </h2>
      
      <mat-dialog-content>
        <mat-form-field class="w-full">
          <mat-label>Filter Name</mat-label>
          <input matInput [(ngModel)]="filterName" 
                 placeholder="Enter filter name"
                 (keyup.enter)="onSave()"
                 autofocus>
        </mat-form-field>
      </mat-dialog-content>
      
      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">
          Cancel
        </button>
        <button mat-raised-button 
                color="primary" 
                (click)="onSave()"
                [disabled]="!filterName?.trim()">
          Save
        </button>
      </mat-dialog-actions>
    </div>
  `,
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatDialogActions, MatDialogContent],
  standalone: true
})
export class FilterNameDialogComponent {
  private dialogRef = inject(MatDialogRef<FilterNameDialogComponent>);
  private data = inject(MAT_DIALOG_DATA);
  
  filterName: string = this.data.defaultName;

  onSave(): void {
    if (this.filterName?.trim()) {
      this.dialogRef.close({ name: this.filterName.trim() });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
} 